let validationTriggered = false;
let sameInfoActive = false;
let sameInfoSourceSeatId = null;
let sameInfoOnChange = null;
let optionalCustomFields = [];

function isOptionalCustomField(fieldLabel) {
    if (!fieldLabel) {
        return false;
    }

    if (Array.isArray(optionalCustomFields)) {
        return optionalCustomFields.indexOf(fieldLabel) !== -1;
    }

    if (optionalCustomFields && typeof optionalCustomFields === 'object') {
        return Object.prototype.hasOwnProperty.call(optionalCustomFields, fieldLabel)
            || Object.values(optionalCustomFields).indexOf(fieldLabel) !== -1;
    }

    return false;
}

function validateEmail(email, texts) {
    if (!email || email.trim() === '') {
        return { valid: false, message: texts.emailRequired || 'Email is required' };
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
        return { valid: false, message: texts.emailInvalid || 'Please enter a valid email address' };
    }

    return { valid: true };
}

function validatePhone(phone, texts) {
    if (!phone || phone.trim() === '') {
        return { valid: false, message: texts.phoneRequired || 'Phone number is required' };
    }

    const phoneRegex = /^[\d\s\-\+\(\)]+$/;
    if (!phoneRegex.test(phone)) {
        return { valid: false, message: texts.phoneInvalid || 'Phone number can only contain digits, spaces, hyphens, parentheses, and plus sign' };
    }

    const cleanPhone = phone.replace(/\D/g, '');

    if (cleanPhone.length < 7) {
        return { valid: false, message: texts.phoneTooShort || 'Phone number must be at least 7 digits' };
    }

    if (cleanPhone.length > 15) {
        return { valid: false, message: texts.phoneTooLong || 'Phone number cannot exceed 15 digits' };
    }

    return { valid: true };
}

function validateFullName(name, texts) {
    if (!name || name.trim() === '') {
        return { valid: false, message: texts.nameRequired || 'Full name is required' };
    }

    if (name.trim().length < 2) {
        return { valid: false, message: texts.nameTooShort || 'Full name must be at least 2 characters' };
    }

    const nameRegex = /^[a-zA-Z\s\-']+$/;
    if (!nameRegex.test(name)) {
        return { valid: false, message: texts.nameInvalid || 'Full name can only contain letters, spaces, hyphens, and apostrophes' };
    }

    return { valid: true };
}

function validateAge(age, texts) {
    if (!age || age === '') {
        return { valid: false, message: texts.ageRequired || 'Age is required' };
    }

    const ageNum = parseInt(age, 10);
    if (Number.isNaN(ageNum) || ageNum < 10 || ageNum > 80) {
        return { valid: false, message: texts.ageInvalid || 'Age must be between 10 and 80' };
    }

    return { valid: true };
}

function validateGender(gender, texts) {
    if (!gender || gender === '') {
        return { valid: false, message: texts.genderRequired || 'Gender is required' };
    }

    const validGenders = [texts.genderMale || 'Male', texts.genderFemale || 'Female'];
    if (!validGenders.includes(gender)) {
        return { valid: false, message: texts.genderInvalid || 'Please select a valid gender' };
    }

    return { valid: true };
}

function validateTshirtSize(size, texts) {
    if (!size || size === '') {
        return { valid: false, message: texts.tshirtRequired || 'T-shirt size is required' };
    }

    const validSizes = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'];
    if (!validSizes.includes(size)) {
        return { valid: false, message: texts.tshirtInvalid || 'Please select a valid T-shirt size' };
    }

    return { valid: true };
}

function validateCustomField(value, texts) {
    if (!value || value.trim() === '') {
        return { valid: false, message: texts.customRequired || 'This field is required' };
    }

    if (value.trim().length < 1) {
        return { valid: false, message: texts.customEmpty || 'This field cannot be empty' };
    }

    return { valid: true };
}

function validateDefaultField(value, texts) {
    if (!value || value.trim() === '') {
        return { valid: false, message: texts.fieldRequired || 'This field is required' };
    }

    return { valid: true };
}

function validateFieldByType(field, value, texts) {
    const fieldType = field.getAttribute('data-field-type');

    switch (fieldType) {
        case 'email':
            return validateEmail(value, texts);
        case 'phone':
            return validatePhone(value, texts);
        case 'full_name':
            return validateFullName(value, texts);
        case 'age':
            return validateAge(value, texts);
        case 'gender':
            return validateGender(value, texts);
        case 'tshirt':
            return validateTshirtSize(value, texts);
        case 'custom':
            return validateCustomField(value, texts);
        default:
            return validateDefaultField(value, texts);
    }
}

function generateRequiredFieldHTML(fieldType, fieldLabel, categoryId, ticketIndex, texts) {
    let html = '';
    const fieldName = `required[${categoryId}][${ticketIndex}]`;
    const requiredMark = '<span style="color: #dc3545;">*</span>';

    switch (fieldType) {
        case 'full_name':
            html = `
                <div class="form-group">
                    <label>${texts.fullNameLabel || 'Full name'} ${requiredMark}</label>
                    <div class="input-group">
                        <input name="${fieldName}[full_name]" class="form-control required" data-type="default" data-field-type="full_name" placeholder="${texts.fullNameLabel || 'Full name'}" type="text" required/>
                    </div>
                </div>
            `;
            break;

        case 'email':
            html = `
                <div class="form-group">
                    <label>${texts.emailLabel || 'Email'} ${requiredMark}</label>
                    <div class="input-group">
                        <input name="${fieldName}[email]" class="form-control required" data-type="default" data-field-type="email" placeholder="${texts.emailLabel || 'Email'}" type="email" required/>
                    </div>
                </div>
            `;
            break;

        case 'age':
            html = `
                <div class="form-group">
                    <label>${texts.ageLabel || 'Age'} ${requiredMark}</label>
                    <select name="${fieldName}[information][age]" class="form-select required" data-type="default" data-field-type="age" required>
                        <option value="">${texts.ageLabel || 'Age'}</option>`;
            for (let i = 10; i <= 80; i++) {
                html += `<option value="${i}">${i}</option>`;
            }
            html += `</select>
                </div>
            `;
            break;

        case 'gender':
            html = `
                <div class="form-group">
                    <label>${texts.genderLabel || 'Gender'} ${requiredMark}</label>
                    <select name="${fieldName}[information][gender]" class="form-control required" data-type="default" data-field-type="gender" required>
                        <option value="">${texts.genderLabel || 'Gender'}</option>
                        <option data-value="m" value="${texts.genderMale || 'Male'}">${texts.genderMale || 'Male'}</option>
                        <option data-value="f" value="${texts.genderFemale || 'Female'}">${texts.genderFemale || 'Female'}</option>
                    </select>
                </div>
            `;
            break;

        case 'phone':
            html = `
                <div class="form-group">
                    <label>${texts.phoneLabel || 'Phone'} ${requiredMark}</label>
                    <div class="input-group">
                        <input name="${fieldName}[phone]" class="form-control required" data-type="default" data-field-type="phone" placeholder="${texts.phoneLabel || 'Phone'}" type="tel" required/>
                    </div>
                </div>
            `;
            break;

        case 'tshirt':
            html = `
                <div class="form-group">
                    <label>${texts.tshirtLabel || 'T-shirt size'} ${requiredMark}</label>
                    <select name="${fieldName}[information][tshirt]" class="form-select required" data-type="default" data-field-type="tshirt" required>
                        <option value="">${texts.tshirtPlaceholder || 'T-Shirt size'}</option>
                        <option value="XXS">XXS</option>
                        <option value="XS">XS</option>
                        <option value="S">S</option>
                        <option value="M">M</option>
                        <option value="L">L</option>
                        <option value="XL">XL</option>
                        <option value="2XL">2XL</option>
                        <option value="3XL">3XL</option>
                    </select>
                </div>
            `;
            break;

        default:
            if (fieldLabel) {
                const fieldNameCustom = fieldLabel.toLowerCase().replace(/\s+/g, '_');
                const isOptional = isOptionalCustomField(fieldLabel);
                const labelSuffix = isOptional ? '' : ` ${requiredMark}`;
                const requiredClass = isOptional ? '' : ' required';
                const requiredAttr = isOptional ? '' : ' required';
                html = `
                    <div class="form-group">
                        <label>${fieldLabel}${labelSuffix}</label>
                        <input name="${fieldName}[${fieldNameCustom}]" class="form-control${requiredClass}" data-type="custom" data-field-type="custom" placeholder="${fieldLabel}" type="text"${requiredAttr}/>
                    </div>
                `;
            }
            break;
    }

    return html;
}

function buildFieldsHtml(fields, categoryId, ticketIndex, texts) {
    let ticketFieldsHtml = '';

    if (fields && Array.isArray(fields)) {
        fields.forEach((field) => {
            if (field.type === 'default') {
                ticketFieldsHtml += generateRequiredFieldHTML(field.field_type, null, categoryId, ticketIndex, texts);
            } else if (field.type === 'custom') {
                ticketFieldsHtml += generateRequiredFieldHTML('custom', field.field_label, categoryId, ticketIndex, texts);
            }
        });
    }

    return ticketFieldsHtml;
}

function clearValidationState(sectionId) {
    const requiredSection = document.getElementById(sectionId || 'required-information-section');
    if (!requiredSection) {
        return;
    }

    const fields = requiredSection.querySelectorAll('input[required], select[required]');

    fields.forEach((field) => {
        field.style.borderColor = '';
        field.classList.remove('is-invalid', 'is-valid');

        const errorElement = field.parentNode.querySelector('.invalid-feedback');
        if (errorElement) {
            errorElement.remove();
        }
    });
}

function getRequiredFieldsRoot(sectionId) {
    const selectedTickets = document.getElementById('selected-tickets');
    if (selectedTickets && selectedTickets.querySelector('.seat-ticket-card.has-required-fields')) {
        return selectedTickets;
    }

    return document.getElementById(sectionId || 'required-information-section');
}

function handleFieldValidation(event, texts, onChange) {
    const field = event.target;
    const validation = validateFieldByType(field, field.value, texts);

    if (!validation.valid) {
        field.style.borderColor = '#dc3545';
        field.classList.add('is-invalid');
        field.classList.remove('is-valid');

        let errorElement = field.parentNode.querySelector('.invalid-feedback');
        if (!errorElement) {
            errorElement = document.createElement('div');
            errorElement.className = 'invalid-feedback';
            field.parentNode.appendChild(errorElement);
        }
        errorElement.textContent = validation.message;
    } else {
        field.style.borderColor = '';
        field.classList.remove('is-invalid');
        field.classList.add('is-valid');

        const errorElement = field.parentNode.querySelector('.invalid-feedback');
        if (errorElement) {
            errorElement.remove();
        }
    }

    if (typeof onChange === 'function') {
        onChange();
    }
}

function addRealTimeValidation(sectionId, texts, onChange) {
    const requiredSection = document.getElementById(sectionId || 'required-information-section');
    if (!requiredSection) {
        return;
    }

    const fields = requiredSection.querySelectorAll('input[required], select[required]');

    fields.forEach((field) => {
        field.removeEventListener('blur', field._requiredInfoBlurHandler);
        field.removeEventListener('input', field._requiredInfoInputHandler);

        if (validationTriggered) {
            field._requiredInfoBlurHandler = (event) => handleFieldValidation(event, texts, onChange);
            field._requiredInfoInputHandler = (event) => handleFieldValidation(event, texts, onChange);
            field.addEventListener('blur', field._requiredInfoBlurHandler);
            field.addEventListener('input', field._requiredInfoInputHandler);
        }
    });
}

function collectFieldsetData(container) {
    const fieldsetData = [];

    container.querySelectorAll('input, select').forEach((field) => {
        if (field.classList.contains('same-info-for-all-checkbox')) {
            return;
        }

        let value = field.value;

        if (field.tagName === 'SELECT') {
            const selectedOption = field.options[field.selectedIndex];
            if (selectedOption && selectedOption.dataset.value) {
                value = selectedOption.dataset.value;
            }
        }

        fieldsetData.push({
            type: field.dataset.type || 'custom',
            field_type: field.dataset.fieldType || field.type,
            field_label: field.dataset.type === 'custom' ? field.placeholder : null,
            value,
        });
    });

    return fieldsetData;
}

function getTicketCards() {
    return Array.from(document.querySelectorAll('#selected-tickets .seat-ticket-card.has-required-fields'));
}

function getTicketFieldContainers() {
    return getTicketCards()
        .map((card) => card.querySelector('.ticket-card-fields'))
        .filter(Boolean);
}

function fieldKey(el) {
    const fieldType = el.getAttribute('data-field-type') || el.type || '';
    const name = el.getAttribute('name') || '';
    const match = name.match(/\[([^\[\]]+)\]$/);
    const trailing = match ? match[1] : name;
    return `${fieldType}::${trailing}`;
}

function copyFields(sourceContainer, targetContainer) {
    if (!sourceContainer || !targetContainer || sourceContainer === targetContainer) {
        return;
    }

    const sourceFields = sourceContainer.querySelectorAll('input:not(.same-info-for-all-checkbox), select');
    const targetByKey = {};

    targetContainer.querySelectorAll('input:not(.same-info-for-all-checkbox), select').forEach((field) => {
        targetByKey[fieldKey(field)] = field;
    });

    sourceFields.forEach((sourceField) => {
        const targetField = targetByKey[fieldKey(sourceField)];
        if (!targetField) {
            return;
        }

        if (sourceField.tagName === 'SELECT') {
            targetField.value = sourceField.value;
            if (sourceField.selectedIndex >= 0) {
                targetField.selectedIndex = sourceField.selectedIndex;
            }
        } else {
            targetField.value = sourceField.value;
        }
    });
}

function setFieldsEditable(card, editable) {
    if (!card) {
        return;
    }

    const container = card.querySelector('.ticket-card-fields');
    if (!container) {
        return;
    }

    card.classList.toggle('is-locked', !editable);

    container.querySelectorAll('input:not(.same-info-for-all-checkbox), select').forEach((field) => {
        if (field.tagName === 'SELECT') {
            field.disabled = !editable;
        } else {
            field.readOnly = !editable;
            if (!editable) {
                field.setAttribute('aria-readonly', 'true');
            } else {
                field.removeAttribute('aria-readonly');
            }
        }
    });
}

function setAllCheckboxes(checked) {
    document.querySelectorAll('#selected-tickets .same-info-for-all-checkbox').forEach((checkbox) => {
        checkbox.checked = checked;
    });
}

function getSourceCard() {
    const cards = getTicketCards();
    if (!cards.length) {
        return null;
    }

    if (sameInfoSourceSeatId) {
        const match = cards.find((card) => card.getAttribute('data-seat-id') === sameInfoSourceSeatId);
        if (match) {
            return match;
        }
    }

    return cards[0];
}

function syncSameInfoFromSource() {
    if (!sameInfoActive) {
        return;
    }

    const sourceCard = getSourceCard();
    if (!sourceCard) {
        return;
    }

    const sourceContainer = sourceCard.querySelector('.ticket-card-fields');
    getTicketCards().forEach((card) => {
        if (card === sourceCard) {
            setFieldsEditable(card, true);
            return;
        }
        copyFields(sourceContainer, card.querySelector('.ticket-card-fields'));
        setFieldsEditable(card, false);
    });
}

function applySameInfoForAll(sourceCard, checked) {
    sameInfoActive = Boolean(checked);

    if (!sameInfoActive) {
        sameInfoSourceSeatId = null;
        setAllCheckboxes(false);
        getTicketCards().forEach((card) => setFieldsEditable(card, true));
        if (typeof sameInfoOnChange === 'function') {
            sameInfoOnChange();
        }
        return;
    }

    sameInfoSourceSeatId = sourceCard
        ? sourceCard.getAttribute('data-seat-id')
        : null;
    setAllCheckboxes(true);
    syncSameInfoFromSource();

    if (typeof sameInfoOnChange === 'function') {
        sameInfoOnChange();
    }
}

function buildSameInfoCheckboxHtml(texts) {
    const label = texts.sameInfoForAllLabel || 'Same information for all tickets';
    return `
        <label class="same-info-for-all">
            <input type="checkbox" class="same-info-for-all-checkbox" />
            <span>${label}</span>
        </label>
    `;
}

function bindSameInfoControls(texts, onChange) {
    sameInfoOnChange = onChange;
    const cards = getTicketCards();

    if (cards.length < 2) {
        sameInfoActive = false;
        sameInfoSourceSeatId = null;
        cards.forEach((card) => {
            const existing = card.querySelector('.same-info-for-all');
            if (existing) {
                existing.remove();
            }
            setFieldsEditable(card, true);
        });
        return;
    }

    cards.forEach((card) => {
        const fieldsEl = card.querySelector('.ticket-card-fields');
        if (!fieldsEl) {
            return;
        }

        let wrap = fieldsEl.querySelector('.same-info-for-all');
        if (!wrap) {
            fieldsEl.insertAdjacentHTML('beforeend', buildSameInfoCheckboxHtml(texts));
            wrap = fieldsEl.querySelector('.same-info-for-all');
        }

        const checkbox = wrap ? wrap.querySelector('.same-info-for-all-checkbox') : null;
        if (!checkbox) {
            return;
        }

        checkbox.checked = sameInfoActive;
        checkbox.onchange = (event) => {
            applySameInfoForAll(card, event.target.checked);
        };
    });

    if (sameInfoActive) {
        const sourceStillExists = sameInfoSourceSeatId
            && cards.some((card) => card.getAttribute('data-seat-id') === sameInfoSourceSeatId);
        if (!sourceStillExists) {
            sameInfoSourceSeatId = cards[0].getAttribute('data-seat-id');
        }
        setAllCheckboxes(true);
        syncSameInfoFromSource();
    }

    cards.forEach((card) => {
        const fieldsEl = card.querySelector('.ticket-card-fields');
        if (!fieldsEl) {
            return;
        }

        fieldsEl.querySelectorAll('input:not(.same-info-for-all-checkbox), select').forEach((field) => {
            const syncHandler = () => {
                if (!sameInfoActive) {
                    return;
                }
                const sourceCard = getSourceCard();
                if (!sourceCard || card !== sourceCard) {
                    return;
                }
                syncSameInfoFromSource();
                if (typeof sameInfoOnChange === 'function') {
                    sameInfoOnChange();
                }
            };

            field.removeEventListener('input', field._sameInfoSyncHandler);
            field.removeEventListener('change', field._sameInfoSyncHandler);
            field._sameInfoSyncHandler = syncHandler;
            field.addEventListener('input', syncHandler);
            field.addEventListener('change', syncHandler);
        });
    });
}

export const RequiredInformationForm = {
    setValidationTriggered(value) {
        validationTriggered = Boolean(value);
    },

    isSectionVisible(sectionId) {
        const selectedTickets = document.getElementById('selected-tickets');
        if (selectedTickets && selectedTickets.querySelector('.seat-ticket-card.has-required-fields')) {
            return true;
        }

        const section = document.getElementById(sectionId || 'required-information-section');
        return Boolean(section && section.style.display !== 'none');
    },

    updateSection({
        requiredInfoData,
        categoryId,
        quantity = 1,
        seatLabels = [],
        texts = {},
        optionalCustomFields: optionalCustomFieldsConfig = {},
        sectionId = 'required-information-section',
        fieldsContainerId = 'required-information-fields',
        onChange = null,
    }) {
        optionalCustomFields = Array.isArray(optionalCustomFieldsConfig)
            ? optionalCustomFieldsConfig
            : (optionalCustomFieldsConfig && typeof optionalCustomFieldsConfig === 'object'
                ? optionalCustomFieldsConfig
                : []);

        const requiredInfoSection = document.getElementById(sectionId);
        const requiredInfoFields = document.getElementById(fieldsContainerId);
        const ticketCards = document.querySelectorAll('#selected-tickets .seat-ticket-card');
        const useInlineCards = ticketCards.length > 0;

        const existingValues = {};
        const valueRoot = useInlineCards
            ? document.getElementById('selected-tickets')
            : requiredInfoFields;

        if (valueRoot) {
            valueRoot.querySelectorAll('input, select').forEach((field) => {
                if (field.name && field.value) {
                    existingValues[field.name] = field.value;
                }
            });
        }

        const ticketData = requiredInfoData && categoryId ? requiredInfoData[categoryId] : null;
        const hasRequiredInfo = Boolean(ticketData && quantity > 0);

        if (!hasRequiredInfo) {
            sameInfoActive = false;
            sameInfoSourceSeatId = null;
            if (requiredInfoSection) {
                requiredInfoSection.style.display = 'none';
            }
            if (requiredInfoFields) {
                requiredInfoFields.innerHTML = '';
            }
            ticketCards.forEach((card) => {
                const fieldsEl = card.querySelector('.ticket-card-fields');
                if (fieldsEl) {
                    fieldsEl.innerHTML = '';
                }
                card.classList.remove('has-required-fields', 'is-locked');
            });
            return false;
        }

        if (useInlineCards) {
            if (requiredInfoSection) {
                requiredInfoSection.style.display = 'none';
            }
            if (requiredInfoFields) {
                requiredInfoFields.innerHTML = '';
            }

            ticketCards.forEach((card, ticketIndex) => {
                const fieldsEl = card.querySelector('.ticket-card-fields');
                if (!fieldsEl) {
                    return;
                }
                const ticketFieldsHtml = buildFieldsHtml(ticketData.fields, categoryId, ticketIndex, texts);
                fieldsEl.innerHTML = ticketFieldsHtml;
                card.classList.add('has-required-fields');
                card.classList.remove('is-locked');
                card.dataset.categoryId = String(categoryId);
            });

            window.setTimeout(() => {
                const selectedTickets = document.getElementById('selected-tickets');
                if (!selectedTickets) {
                    return;
                }

                clearValidationState('selected-tickets');

                Object.keys(existingValues).forEach((fieldName) => {
                    const field = selectedTickets.querySelector(`[name="${fieldName}"]`);
                    if (field && existingValues[fieldName]) {
                        field.value = existingValues[fieldName];
                    }
                });

                selectedTickets.querySelectorAll('input[required], select[required]').forEach((field) => {
                    if (typeof onChange === 'function') {
                        field.addEventListener('input', onChange);
                        field.addEventListener('change', onChange);
                    }
                });

                bindSameInfoControls(texts, onChange);
                addRealTimeValidation('selected-tickets', texts, onChange);
            }, 100);

            return true;
        }

        if (!requiredInfoSection || !requiredInfoFields) {
            return false;
        }

        let fieldsHtml = '';
        const ticketCount = Math.max(1, parseInt(quantity, 10) || 1);

        fieldsHtml += `<div class="ticket-required-info" data-category-id="${categoryId}">`;

        for (let ticketIndex = 0; ticketIndex < ticketCount; ticketIndex++) {
            const seatLabel = seatLabels[ticketIndex] || `${ticketData.name} ${ticketIndex + 1}`;
            const ticketFieldsHtml = buildFieldsHtml(ticketData.fields, categoryId, ticketIndex, texts);

            fieldsHtml += `
                <div class="info-group">
                    <h6 class="ticket-info-title">${seatLabel}</h6>
                    <div class="ticket-info-fields">
                        ${ticketFieldsHtml}
                    </div>
                </div>
            `;
        }

        fieldsHtml += '</div>';

        requiredInfoFields.innerHTML = fieldsHtml;
        requiredInfoSection.style.display = 'block';

        window.setTimeout(() => {
            clearValidationState(sectionId);

            Object.keys(existingValues).forEach((fieldName) => {
                const field = requiredInfoFields.querySelector(`[name="${fieldName}"]`);
                if (field && existingValues[fieldName]) {
                    field.value = existingValues[fieldName];
                }
            });

            const requiredFields = requiredInfoSection.querySelectorAll('input[required], select[required]');
            requiredFields.forEach((field) => {
                if (typeof onChange === 'function') {
                    field.addEventListener('input', onChange);
                    field.addEventListener('change', onChange);
                }
            });

            addRealTimeValidation(sectionId, texts, onChange);
        }, 100);

        return true;
    },

    validate(texts = {}, sectionId = 'required-information-section') {
        const requiredSection = getRequiredFieldsRoot(sectionId);

        if (!requiredSection) {
            return { valid: true };
        }

        if (requiredSection.id !== 'selected-tickets' && requiredSection.style.display === 'none') {
            return { valid: true };
        }

        const requiredFields = requiredSection.querySelectorAll('input[required], select[required]');
        let allValid = true;
        let firstInvalidField = null;

        validationTriggered = true;

        requiredFields.forEach((field) => {
            const validation = validateFieldByType(field, field.value, texts);

            if (!validation.valid) {
                allValid = false;
                if (!firstInvalidField) {
                    firstInvalidField = field;
                }

                field.style.borderColor = '#dc3545';
                field.classList.add('is-invalid');
                field.classList.remove('is-valid');

                let errorElement = field.parentNode.querySelector('.invalid-feedback');
                if (!errorElement) {
                    errorElement = document.createElement('div');
                    errorElement.className = 'invalid-feedback';
                    field.parentNode.appendChild(errorElement);
                }
                errorElement.textContent = validation.message;

                const ticketCard = field.closest('.seat-ticket-card');
                if (ticketCard) {
                    ticketCard.classList.add('is-expanded');
                }
            } else {
                field.style.borderColor = '';
                field.classList.remove('is-invalid');
                field.classList.add('is-valid');

                const errorElement = field.parentNode.querySelector('.invalid-feedback');
                if (errorElement) {
                    errorElement.remove();
                }
            }
        });

        return {
            valid: allValid,
            firstInvalidField,
        };
    },

    scrollToFirstInvalidField(firstInvalidField) {
        if (!firstInvalidField) {
            return;
        }

        const ticketCard = firstInvalidField.closest('.seat-ticket-card');
        if (ticketCard) {
            ticketCard.classList.add('is-expanded');
        }

        firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(() => firstInvalidField.focus(), 300);
    },

    save({ hiddenInputId = 'order-info', fieldsContainerId = 'required-information-fields' } = {}) {
        const hiddenInput = document.getElementById(hiddenInputId);
        if (!hiddenInput) {
            return;
        }

        if (sameInfoActive) {
            syncSameInfoFromSource();
        }

        const selectedTickets = document.getElementById('selected-tickets');
        const inlineCards = selectedTickets
            ? selectedTickets.querySelectorAll('.seat-ticket-card.has-required-fields')
            : [];

        if (inlineCards.length > 0) {
            const categoryId = inlineCards[0].dataset.categoryId;
            const categoryData = { category_id: categoryId, information: [] };

            inlineCards.forEach((card) => {
                const fieldsEl = card.querySelector('.ticket-card-fields');
                if (!fieldsEl) {
                    return;
                }
                const fieldsetData = collectFieldsetData(fieldsEl);
                if (fieldsetData.length > 0) {
                    categoryData.information.push(fieldsetData);
                }
            });

            hiddenInput.value = categoryData.information.length > 0
                ? JSON.stringify([categoryData])
                : '';
            return;
        }

        const requiredInfoFields = document.getElementById(fieldsContainerId);

        if (!requiredInfoFields) {
            return;
        }

        const saveRequiredInformation = [];

        requiredInfoFields.querySelectorAll('.ticket-required-info').forEach((ticketRequiredInfo) => {
            const categoryId = ticketRequiredInfo.dataset.categoryId;
            const categoryData = { category_id: categoryId, information: [] };

            ticketRequiredInfo.querySelectorAll('.info-group').forEach((infoGroup) => {
                const fieldsetData = collectFieldsetData(infoGroup);

                if (fieldsetData.length > 0) {
                    categoryData.information.push(fieldsetData);
                }
            });

            if (categoryData.information.length === 0) {
                const legacyContainer = ticketRequiredInfo.querySelector(':scope > .ticket-info-fields');
                if (legacyContainer) {
                    const fieldsetData = collectFieldsetData(legacyContainer);

                    if (fieldsetData.length > 0) {
                        categoryData.information.push(fieldsetData);
                    }
                }
            }

            if (categoryData.information.length > 0) {
                saveRequiredInformation.push(categoryData);
            }
        });

        hiddenInput.value = JSON.stringify(saveRequiredInformation);
    },

    bindRealtimeValidation(texts = {}, onChange = null, sectionId = 'required-information-section') {
        const root = getRequiredFieldsRoot(sectionId);
        addRealTimeValidation(root ? root.id : sectionId, texts, onChange);
    },

    clearValidationState(sectionId = 'required-information-section') {
        const root = getRequiredFieldsRoot(sectionId);
        clearValidationState(root ? root.id : sectionId);
    },

    areFieldsFilled(texts = {}, sectionId = 'required-information-section') {
        const requiredSection = getRequiredFieldsRoot(sectionId);

        if (!requiredSection) {
            return true;
        }

        if (requiredSection.id !== 'selected-tickets' && requiredSection.style.display === 'none') {
            return true;
        }

        const requiredFields = requiredSection.querySelectorAll('input[required], select[required]');

        for (const field of requiredFields) {
            const validation = validateFieldByType(field, field.value, texts);
            if (!validation.valid) {
                return false;
            }
        }

        return true;
    },
};
